/* Quick Shop — opens a mini-PDP modal from collection cards, fetched via the
   Section Rendering API. Self-contained: variant/qty/ATC handled here rather than
   the theme's product JS (which doesn't re-init on injected DOM). */
(function () {
  var modal = document.querySelector('[data-hp-qs-modal]');
  if (!modal) return;
  var body = modal.querySelector('[data-hp-qs-body]');
  var loadingHTML = '<div class="hp-qs-modal__loading">Loading…</div>';
  var lastFocus = null;

  /* ---------- open / close ---------- */
  function openModal() {
    lastFocus = document.activeElement;
    modal.hidden = false;
    document.documentElement.style.overflow = 'hidden';
    modal.querySelector('.hp-qs-modal__close').focus();
  }
  function closeModal() {
    modal.hidden = true;
    document.documentElement.style.overflow = '';
    body.innerHTML = loadingHTML;
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }
  modal.addEventListener('click', function (e) {
    if (e.target.closest('[data-hp-qs-close]')) closeModal();
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && !modal.hidden) closeModal();
  });

  /* ---------- trigger: + Add on a card ---------- */
  // Capture phase + stopPropagation: the button now lives inside the product
  // link, so we must intercept the click before the anchor navigates.
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-hp-quick-add]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    var handle = btn.getAttribute('data-handle');
    if (!handle) return;
    openModal();
    body.innerHTML = loadingHTML;
    fetch('/products/' + handle + '?section_id=hp-quick-shop', { cache: 'no-store' })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        // Section Rendering API wraps output in a shopify-section div; take its inner content
        var tmp = document.createElement('div');
        tmp.innerHTML = html;
        var section = tmp.querySelector('[data-hp-qs]') ? tmp : null;
        body.innerHTML = tmp.innerHTML;
        init(body);
      })
      .catch(function () {
        body.innerHTML = '<div class="hp-qs-modal__loading">Sorry — could not load this product. <a href="/products/' + handle + '">View it here</a>.</div>';
      });
  }, true);

  /* ---------- init the injected mini-PDP ---------- */
  function init(root) {
    var el = root.querySelector('[data-hp-qs]');
    if (!el) return;
    var variants = [];
    try { variants = JSON.parse(root.querySelector('[data-hp-qs-variants]').textContent); } catch (e) {}

    var optionGroups = Array.prototype.slice.call(root.querySelectorAll('[data-hp-qs-option]'));
    var selected = optionGroups.map(function () { return null; }); // force explicit selection
    // clear any pre-marked selection from Liquid
    root.querySelectorAll('[data-hp-qs-value].is-selected').forEach(function (b) { b.classList.remove('is-selected'); });

    var priceEl = root.querySelector('[data-hp-qs-price]');
    var mainImg = root.querySelector('[data-hp-qs-main]');
    // Drop srcset/sizes so setting .src (thumb + variant swaps) actually changes the image.
    if (mainImg) { mainImg.removeAttribute('srcset'); mainImg.removeAttribute('sizes'); }
    var atc = root.querySelector('[data-hp-qs-atc]');
    var atcText = root.querySelector('[data-hp-qs-atc-text]');
    var msg = root.querySelector('[data-hp-qs-msg]');
    var qtyInput = root.querySelector('[data-hp-qs-qty-input]');
    var optionNames = optionGroups.map(function (g) {
      var n = g.querySelector('.hp-qs__option-name'); return n ? n.textContent.trim() : '';
    });
    var singleVariant = optionGroups.length === 0;

    function money(cents) {
      return '$' + (cents / 100).toFixed(2).replace(/\.00$/, '.00');
    }
    function matchVariant() {
      if (selected.indexOf(null) !== -1) return null;
      return variants.find(function (v) {
        return v.options.every(function (o, i) { return o === selected[i]; });
      }) || null;
    }
    function render() {
      var v = matchVariant();
      // mark unavailable values given current partial selection
      optionGroups.forEach(function (g, gi) {
        g.querySelectorAll('[data-hp-qs-value]').forEach(function (btn) {
          var val = btn.getAttribute('data-value');
          var possible = variants.some(function (vt) {
            if (!vt.available) return false;
            return vt.options.every(function (o, i) {
              if (i === gi) return o === val;
              return selected[i] == null || o === selected[i];
            });
          });
          btn.classList.toggle('is-unavailable', !possible);
        });
      });
      if (singleVariant) {
        var only = variants[0];
        setBuy(only && only.available ? only : null, only && !only.available);
        return;
      }
      if (v) {
        setBuy(v.available ? v : null, !v.available);
        if (v.available && priceEl) {
          priceEl.innerHTML = '<span class="hp-qs__price-now">' + money(v.price) + '</span>' +
            (v.compare_at > v.price ? ' <s class="hp-qs__price-was">' + money(v.compare_at) + '</s>' : '');
        }
        if (v.image && mainImg) { mainImg.src = v.image; }
      } else {
        var firstUnset = selected.indexOf(null);
        atc.disabled = true; atc.classList.remove('is-added');
        atcText.textContent = firstUnset > -1 ? ('Select a ' + optionNames[firstUnset]) : 'Unavailable';
      }
    }
    function setBuy(variant, soldout) {
      atc.classList.remove('is-added');
      if (variant) {
        atc.disabled = false;
        atc.setAttribute('data-variant-id', variant.id);
        atcText.textContent = 'Add to Cart';
      } else {
        atc.disabled = true;
        atc.removeAttribute('data-variant-id');
        atcText.textContent = soldout ? 'Sold Out' : atcText.textContent;
      }
    }

    // thumbnails
    root.querySelectorAll('[data-hp-qs-thumb]').forEach(function (t) {
      t.addEventListener('click', function () {
        if (mainImg) mainImg.src = t.getAttribute('data-full');
        root.querySelectorAll('[data-hp-qs-thumb]').forEach(function (x) { x.classList.remove('is-active'); });
        t.classList.add('is-active');
      });
    });
    // option value selection
    optionGroups.forEach(function (g, gi) {
      g.querySelectorAll('[data-hp-qs-value]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          selected[gi] = btn.getAttribute('data-value');
          g.querySelectorAll('[data-hp-qs-value]').forEach(function (x) { x.classList.remove('is-selected'); });
          btn.classList.add('is-selected');
          if (msg) { msg.hidden = true; }
          render();
        });
      });
    });
    // qty
    root.querySelectorAll('[data-hp-qs-qty]').forEach(function (b) {
      b.addEventListener('click', function () {
        var d = parseInt(b.getAttribute('data-hp-qs-qty'), 10);
        var n = Math.max(1, (parseInt(qtyInput.value, 10) || 1) + d);
        qtyInput.value = n;
      });
    });
    // size chart panel (same metafield image the PDP uses)
    var scOpen = root.querySelector('[data-hp-qs-sizechart]');
    var scPanel = root.querySelector('[data-hp-qs-sizechart-panel]');
    if (scOpen && scPanel) {
      scOpen.addEventListener('click', function () { scPanel.hidden = false; });
      var scClose = root.querySelector('[data-hp-qs-sizechart-close]');
      if (scClose) scClose.addEventListener('click', function () { scPanel.hidden = true; });
    }
    // add to cart
    atc.addEventListener('click', function () {
      var id = atc.getAttribute('data-variant-id');
      if (!id || atc.disabled) return;
      var qty = Math.max(1, parseInt(qtyInput.value, 10) || 1);
      atc.disabled = true; atcText.textContent = 'Adding…';
      fetch('/cart/add.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: parseInt(id, 10), quantity: qty }] })
      }).then(function (r) {
        if (!r.ok) throw new Error('add failed');
        return r.json();
      }).then(function () {
        atc.classList.add('is-added'); atcText.textContent = 'Added ✓';
        updateCartCount();
        if (msg) { msg.hidden = false; msg.className = 'hp-qs__msg hp-qs__msg--ok'; msg.innerHTML = 'Added to cart. <a href="/cart">View cart &rsaquo;</a>'; }
        // Close the modal after a brief confirmation; the theme's cart drawer
        // auto-opens on cart change to show the added item.
        setTimeout(closeModal, 900);
      }).catch(function () {
        atc.disabled = false; atcText.textContent = 'Add to Cart';
        if (msg) { msg.hidden = false; msg.className = 'hp-qs__msg hp-qs__msg--error'; msg.textContent = 'Could not add to cart. Please try again.'; }
      });
    });

    // re-hydrate the injected Okendo star rating (AJAX content needs a manual init)
    try {
      if (window.okeWidgetApi && typeof window.okeWidgetApi.initAllWidgets === 'function') window.okeWidgetApi.initAllWidgets();
    } catch (e) {}

    render();
  }

  /* ---------- cart helpers ---------- */
  function updateCartCount() {
    fetch('/cart.js', { cache: 'no-store' }).then(function (r) { return r.json(); }).then(function (c) {
      document.querySelectorAll('.cart-link__bubble, [data-cart-count], .cart-count-bubble').forEach(function (n) {
        var t = n.querySelector('span') || n; t.textContent = c.item_count;
        n.classList.add('cart-link__bubble--visible');
      });
    }).catch(function () {});
  }
})();
